import initTurnstileForms from './modules/turnstile';

initTurnstileForms();
